import { supportedLocalesWithFlags } from './config';

interface ISupportedLocale {
  lKey: string;
  flagSrc: string;
  labelKey: string;
  nativeName: string;
}

export const getSupportedLocales = (): ISupportedLocale[] =>
  [...supportedLocalesWithFlags].map(([lKey, localeInfo]) => ({
    lKey,
    flagSrc: localeInfo.flag,
    labelKey: `frontend.locale.locales.${lKey}`,
    nativeName: localeInfo.nativeName
  }));
